import {Suspense} from 'react'

import type {OptionConfig} from '../utils/option-config'
import type {CreateIssueCallbackProps} from '../CreateIssueForm'
import {CreateIssueDialogEntryInternalV2} from './CreateIssueDialogEntryV2'

export type CreateIssueDialogEntryProps = {
  navigate: (url: string) => void
  isCreateDialogOpen: boolean
  setIsCreateDialogOpen: (value: boolean) => void
  optionConfig?: OptionConfig
  canBypassTemplateSelection?: boolean
  setIsNavigatingToNew?: (isNavigatingToNew: boolean) => void
} & Partial<CreateIssueCallbackProps>
// TODO unify the two CreateIssueDialogEntryV2 implementations
export const CreateIssueDialogEntry = ({...props}: CreateIssueDialogEntryProps): JSX.Element | null => {
  return (
    <Suspense>
      <CreateIssueDialogEntryInternalV2 {...props} />
    </Suspense>
  )
}

try{ CreateIssueDialogEntry.displayName ||= 'CreateIssueDialogEntry' } catch {}